import axios from 'axios'

export default {
    getClaims(page, filter) {
        return axios.get('/api/claims/accounting',
            {
                params: {
                    page: page,
                    q: filter.q,
                    status: filter.type,
                    dateFrom: filter.dateFrom,
                    dateTo: filter.dateTo
                }
            });
    },
    payClaim(id) {
        return axios.post(`/api/claims/${id}/pay`);
    },
    printClaim(id) {
        return axios.get(`/api/claims/${id}/print`);
    },
    processClaim(id) {
        return axios.post(`/api/claims/${id}/process`);
    },
    payAndPrint(listId) {
        return axios.post('/api/claims/payAndPrint', listId);
    },
    // TODO Dunno why we repeat values in each subfolder 
    deleteClaim(id) {
        return axios.delete(`/api/claims/${id}`);
    }
}



// WEBPACK FOOTER //
// ./ClientApp/app/accounting/api.js